import React, { useEffect } from 'react';
import Container from '../components/Container';
import courseImg from "../images/courses/course1.jpeg";
import "../styles/courses.css";
import { BiHomeAlt2 } from "react-icons/bi";
import { getAllCourses } from '../features/courses/courseSlice';
import { useDispatch, useSelector } from 'react-redux';
import CoursesLoader from '../components/CoursesLoader';
import { GrView } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';


const Courses = () => {
  const dispatch = useDispatch();

  const courseState = useSelector((state) => state.course.courses); // Adjust based on your slice
   useEffect(() => {
    dispatch(getAllCourses());
  }, [dispatch]);

  const navigate = useNavigate();

  const handleCourse = (id) => {
    navigate( `/course/${id}`)
   };

  return (
    <>
    <Meta title="Courses"/>
      <Container class1="courses-wrapper">
      <div className='course-header'>
        <div className='courses__overlay'></div>

        <div className='course-header-container'>
          <div className='event-breadcrumb'>
            <a href='/'><BiHomeAlt2 className='home-icon'/></a> | <span>All Courses</span>
          </div>
          <h2>All Courses</h2>
        </div>
        <img src={courseImg} alt="Courses" />
      </div>
 
      <div className="course-container">
        <div className="table-container">
          <table className="courses-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Course Name</th>
                <th>Objective</th>
                <th>Target Group</th>
                <th>Duration</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                  {courseState?.length > 0 ? (
                courseState.map((course, index) => (
                  <tr key={course._id}>
                    <td>{index + 1}</td>
                    <td>{course.title}</td>
                    <td>{course.objective}</td>
                    <td>{course.targetGroup}</td>
                    <td>{course.duration}</td>
                    <td>
                      <button onClick={() => handleCourse(course._id)} className="enroll-btn">
                       View
                      </button>
                    </td>
                  </tr>
                             ))
              ) : (
                 <CoursesLoader/>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </Container>  
    </>

  );
};

export default Courses;
